import React from 'react'
import messageUtil from 'utils/messageUtil'
import { MetricSeries } from 'enums'
import { useTranslation } from 'react-i18next'
import { compactNumberFormatter } from 'utils/numberFormatterUtil'
import PanelColumn from './PanelColumn'
import { NonNullableDataset } from './types'

interface DefaultPanelProps {
  data: NonNullableDataset
}

const PodcastPanel = ({ data }: DefaultPanelProps) => {
  const { t } = useTranslation()

  return (
    <>
      <PanelColumn
        title={t('listen_other')}
        value={compactNumberFormatter({
          value: data.find((metric) => metric.seriesName === MetricSeries.VIEWS)?.set?.[0] || 0,
          precise: false
        })}
      />
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.IMPRESSIONS)}
        value={compactNumberFormatter({
          value:
            data.find((metric) => metric.seriesName === MetricSeries.POST_IMPRESSIONS)?.set?.[0] ||
            0,
          precise: false
        })}
      />
    </>
  )
}
export default PodcastPanel
